/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AssignClassExamSheetBody } from '../models';
// @ts-ignore
import type { ClassExamDetailResponse } from '../models';
// @ts-ignore
import type { ClassExamListResponse } from '../models';
// @ts-ignore
import type { ClassExamSheet } from '../models';
// @ts-ignore
import type { ClassExamSummary } from '../models';
// @ts-ignore
import type { CreateClassExamBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
/**
 * FacultyExamApiApi - axios parameter creator
 */
export const FacultyExamApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} quizId 
         * @param {string} sheetId 
         * @param {AssignClassExamSheetBody} assignClassExamSheetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiAssignExamSheet: async (quizId: string, sheetId: string, assignClassExamSheetBody: AssignClassExamSheetBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('facultyExamApiAssignExamSheet', 'quizId', quizId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('facultyExamApiAssignExamSheet', 'sheetId', sheetId)
            // verify required parameter 'assignClassExamSheetBody' is not null or undefined
            assertParamExists('facultyExamApiAssignExamSheet', 'assignClassExamSheetBody', assignClassExamSheetBody)
            const localVarPath = `/api/v1/faculty/exams/{quiz_id}/sheets/{sheet_id}/student`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)))
                .replace('{sheet_id}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignClassExamSheetBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateClassExamBody} createClassExamBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiCreateExam: async (createClassExamBody: CreateClassExamBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createClassExamBody' is not null or undefined
            assertParamExists('facultyExamApiCreateExam', 'createClassExamBody', createClassExamBody)
            const localVarPath = `/api/v1/faculty/exams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClassExamBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiGetExam: async (quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('facultyExamApiGetExam', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/exams/{quiz_id}`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiListExams: async (classId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyExamApiListExams', 'classId', classId)
            const localVarPath = `/api/v1/faculty/exams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (classId !== undefined) {
                localVarQueryParameter['class_id'] = classId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiRemoveExamSheet: async (quizId: string, sheetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('facultyExamApiRemoveExamSheet', 'quizId', quizId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('facultyExamApiRemoveExamSheet', 'sheetId', sheetId)
            const localVarPath = `/api/v1/faculty/exams/{quiz_id}/sheets/{sheet_id}`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)))
                .replace('{sheet_id}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiRetryExamSheet: async (quizId: string, sheetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('facultyExamApiRetryExamSheet', 'quizId', quizId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('facultyExamApiRetryExamSheet', 'sheetId', sheetId)
            const localVarPath = `/api/v1/faculty/exams/{quiz_id}/sheets/{sheet_id}/retry`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)))
                .replace('{sheet_id}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiStartExamGrading: async (quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('facultyExamApiStartExamGrading', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/exams/{quiz_id}/start`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {File} sheet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiUploadExamSheet: async (quizId: string, sheet: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('facultyExamApiUploadExamSheet', 'quizId', quizId)
            // verify required parameter 'sheet' is not null or undefined
            assertParamExists('facultyExamApiUploadExamSheet', 'sheet', sheet)
            const localVarPath = `/api/v1/faculty/exams/{quiz_id}/sheets`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (sheet !== undefined) { 
                localVarFormParams.append('sheet', sheet as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacultyExamApiApi - functional programming interface
 */
export const FacultyExamApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacultyExamApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} quizId 
         * @param {string} sheetId 
         * @param {AssignClassExamSheetBody} assignClassExamSheetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyExamApiAssignExamSheet(quizId: string, sheetId: string, assignClassExamSheetBody: AssignClassExamSheetBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassExamSheet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyExamApiAssignExamSheet(quizId, sheetId, assignClassExamSheetBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyExamApiApi.facultyExamApiAssignExamSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateClassExamBody} createClassExamBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyExamApiCreateExam(createClassExamBody: CreateClassExamBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassExamSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyExamApiCreateExam(createClassExamBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyExamApiApi.facultyExamApiCreateExam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyExamApiGetExam(quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassExamDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyExamApiGetExam(quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyExamApiApi.facultyExamApiGetExam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyExamApiListExams(classId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassExamListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyExamApiListExams(classId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyExamApiApi.facultyExamApiListExams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyExamApiRemoveExamSheet(quizId: string, sheetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyExamApiRemoveExamSheet(quizId, sheetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyExamApiApi.facultyExamApiRemoveExamSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyExamApiRetryExamSheet(quizId: string, sheetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassExamSheet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyExamApiRetryExamSheet(quizId, sheetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyExamApiApi.facultyExamApiRetryExamSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyExamApiStartExamGrading(quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassExamSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyExamApiStartExamGrading(quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyExamApiApi.facultyExamApiStartExamGrading']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {File} sheet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyExamApiUploadExamSheet(quizId: string, sheet: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassExamSheet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyExamApiUploadExamSheet(quizId, sheet, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyExamApiApi.facultyExamApiUploadExamSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FacultyExamApiApi - factory interface
 */
export const FacultyExamApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacultyExamApiApiFp(configuration)
    return {
        /**
         * 
         * @param {FacultyExamApiApiFacultyExamApiAssignExamSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiAssignExamSheet(requestParameters: FacultyExamApiApiFacultyExamApiAssignExamSheetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassExamSheet> {
            return localVarFp.facultyExamApiAssignExamSheet(requestParameters.quizId, requestParameters.sheetId, requestParameters.assignClassExamSheetBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyExamApiApiFacultyExamApiCreateExamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiCreateExam(requestParameters: FacultyExamApiApiFacultyExamApiCreateExamRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassExamSummary> {
            return localVarFp.facultyExamApiCreateExam(requestParameters.createClassExamBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyExamApiApiFacultyExamApiGetExamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiGetExam(requestParameters: FacultyExamApiApiFacultyExamApiGetExamRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassExamDetailResponse> {
            return localVarFp.facultyExamApiGetExam(requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyExamApiApiFacultyExamApiListExamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiListExams(requestParameters: FacultyExamApiApiFacultyExamApiListExamsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassExamListResponse> {
            return localVarFp.facultyExamApiListExams(requestParameters.classId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyExamApiApiFacultyExamApiRemoveExamSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiRemoveExamSheet(requestParameters: FacultyExamApiApiFacultyExamApiRemoveExamSheetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.facultyExamApiRemoveExamSheet(requestParameters.quizId, requestParameters.sheetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyExamApiApiFacultyExamApiRetryExamSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiRetryExamSheet(requestParameters: FacultyExamApiApiFacultyExamApiRetryExamSheetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassExamSheet> {
            return localVarFp.facultyExamApiRetryExamSheet(requestParameters.quizId, requestParameters.sheetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyExamApiApiFacultyExamApiStartExamGradingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiStartExamGrading(requestParameters: FacultyExamApiApiFacultyExamApiStartExamGradingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassExamSummary> {
            return localVarFp.facultyExamApiStartExamGrading(requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyExamApiApiFacultyExamApiUploadExamSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyExamApiUploadExamSheet(requestParameters: FacultyExamApiApiFacultyExamApiUploadExamSheetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassExamSheet> {
            return localVarFp.facultyExamApiUploadExamSheet(requestParameters.quizId, requestParameters.sheet, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for facultyExamApiAssignExamSheet operation in FacultyExamApiApi.
 */
export interface FacultyExamApiApiFacultyExamApiAssignExamSheetRequest {
    readonly quizId: string

    readonly sheetId: string

    readonly assignClassExamSheetBody: AssignClassExamSheetBody
}

/**
 * Request parameters for facultyExamApiCreateExam operation in FacultyExamApiApi.
 */
export interface FacultyExamApiApiFacultyExamApiCreateExamRequest {
    readonly createClassExamBody: CreateClassExamBody
}

/**
 * Request parameters for facultyExamApiGetExam operation in FacultyExamApiApi.
 */
export interface FacultyExamApiApiFacultyExamApiGetExamRequest {
    readonly quizId: string
}

/**
 * Request parameters for facultyExamApiListExams operation in FacultyExamApiApi.
 */
export interface FacultyExamApiApiFacultyExamApiListExamsRequest {
    readonly classId: string
}

/**
 * Request parameters for facultyExamApiRemoveExamSheet operation in FacultyExamApiApi.
 */
export interface FacultyExamApiApiFacultyExamApiRemoveExamSheetRequest {
    readonly quizId: string

    readonly sheetId: string
}

/**
 * Request parameters for facultyExamApiRetryExamSheet operation in FacultyExamApiApi.
 */
export interface FacultyExamApiApiFacultyExamApiRetryExamSheetRequest {
    readonly quizId: string

    readonly sheetId: string
}

/**
 * Request parameters for facultyExamApiStartExamGrading operation in FacultyExamApiApi.
 */
export interface FacultyExamApiApiFacultyExamApiStartExamGradingRequest {
    readonly quizId: string
}

/**
 * Request parameters for facultyExamApiUploadExamSheet operation in FacultyExamApiApi.
 */
export interface FacultyExamApiApiFacultyExamApiUploadExamSheetRequest {
    readonly quizId: string

    readonly sheet: File
}

/**
 * FacultyExamApiApi - object-oriented interface
 */
export class FacultyExamApiApi extends BaseAPI {
    /**
     * 
     * @param {FacultyExamApiApiFacultyExamApiAssignExamSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyExamApiAssignExamSheet(requestParameters: FacultyExamApiApiFacultyExamApiAssignExamSheetRequest, options?: RawAxiosRequestConfig) {
        return FacultyExamApiApiFp(this.configuration).facultyExamApiAssignExamSheet(requestParameters.quizId, requestParameters.sheetId, requestParameters.assignClassExamSheetBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyExamApiApiFacultyExamApiCreateExamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyExamApiCreateExam(requestParameters: FacultyExamApiApiFacultyExamApiCreateExamRequest, options?: RawAxiosRequestConfig) {
        return FacultyExamApiApiFp(this.configuration).facultyExamApiCreateExam(requestParameters.createClassExamBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyExamApiApiFacultyExamApiGetExamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyExamApiGetExam(requestParameters: FacultyExamApiApiFacultyExamApiGetExamRequest, options?: RawAxiosRequestConfig) {
        return FacultyExamApiApiFp(this.configuration).facultyExamApiGetExam(requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyExamApiApiFacultyExamApiListExamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyExamApiListExams(requestParameters: FacultyExamApiApiFacultyExamApiListExamsRequest, options?: RawAxiosRequestConfig) {
        return FacultyExamApiApiFp(this.configuration).facultyExamApiListExams(requestParameters.classId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyExamApiApiFacultyExamApiRemoveExamSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyExamApiRemoveExamSheet(requestParameters: FacultyExamApiApiFacultyExamApiRemoveExamSheetRequest, options?: RawAxiosRequestConfig) {
        return FacultyExamApiApiFp(this.configuration).facultyExamApiRemoveExamSheet(requestParameters.quizId, requestParameters.sheetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyExamApiApiFacultyExamApiRetryExamSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyExamApiRetryExamSheet(requestParameters: FacultyExamApiApiFacultyExamApiRetryExamSheetRequest, options?: RawAxiosRequestConfig) {
        return FacultyExamApiApiFp(this.configuration).facultyExamApiRetryExamSheet(requestParameters.quizId, requestParameters.sheetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyExamApiApiFacultyExamApiStartExamGradingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyExamApiStartExamGrading(requestParameters: FacultyExamApiApiFacultyExamApiStartExamGradingRequest, options?: RawAxiosRequestConfig) {
        return FacultyExamApiApiFp(this.configuration).facultyExamApiStartExamGrading(requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyExamApiApiFacultyExamApiUploadExamSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyExamApiUploadExamSheet(requestParameters: FacultyExamApiApiFacultyExamApiUploadExamSheetRequest, options?: RawAxiosRequestConfig) {
        return FacultyExamApiApiFp(this.configuration).facultyExamApiUploadExamSheet(requestParameters.quizId, requestParameters.sheet, options).then((request) => request(this.axios, this.basePath));
    }
}

